/* BM7 collection: client-side category filtering + live search + sort.
   Loads every product in the collection (the Liquid grid is only a no-JS
   fallback that caps at one paginate page), derives category chips from the
   product titles, and filters/searches/sorts entirely on the page. */
(function () {
  'use strict';

  function esc(s) {
    return (s == null ? '' : String(s))
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function withWidth(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // BM7 fabric convention: cascade, stack, swirl, model (4th). Hover uses model.
  function modelImage(imgs) {
    if (!imgs || !imgs.length) return '';
    if (imgs.length >= 4) return imgs[3];
    for (var i = imgs.length - 1; i >= 0; i--) {
      if (/model/i.test(imgs[i])) return imgs[i];
    }
    return imgs.length > 1 ? imgs[imgs.length - 1] : '';
  }

  // Shopify-style money formatter (operates on integer cents).
  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = (typeof precision === 'undefined') ? 2 : precision;
      thousands = (typeof thousands === 'undefined') ? ',' : thousands;
      decimal = (typeof decimal === 'undefined') ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? (decimal + parts[1]) : '';
      return dollars + centsPart;
    }
    var value = '';
    var match = (format || '').match(placeholder);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'"); break;
      default: value = withDelimiters(cents, 2);
    }
    return (format || '${{amount}}').replace(placeholder, value);
  }

  // Parse "Label: kw1, kw2" lines into an ordered matcher list (specific first).
  function parseCategories(raw) {
    var cats = [];
    (raw || '').split('\n').forEach(function (line) {
      line = line.trim();
      if (!line) return;
      var idx = line.indexOf(':');
      if (idx === -1) return;
      var label = line.slice(0, idx).trim();
      var kws = line.slice(idx + 1).split(',').map(function (k) {
        return k.trim().toLowerCase();
      }).filter(Boolean);
      if (label && kws.length) cats.push({ label: label, kw: kws });
    });
    return cats;
  }

  // Parse "Parent > Sub label: kw1, kw2" lines into { parent: [{label, kw}] }.
  function parseSubcategories(raw) {
    var map = {};
    (raw || '').split('\n').forEach(function (line) {
      line = line.trim();
      if (!line) return;
      var gt = line.indexOf('>');
      if (gt === -1) return;
      var parent = line.slice(0, gt).trim();
      var rest = line.slice(gt + 1);
      var colon = rest.indexOf(':');
      if (colon === -1) return;
      var label = rest.slice(0, colon).trim();
      var kws = rest.slice(colon + 1).split(',').map(function (k) {
        return k.trim().toLowerCase();
      }).filter(Boolean);
      if (parent && label && kws.length) {
        if (!map[parent]) map[parent] = [];
        map[parent].push({ label: label, kw: kws });
      }
    });
    return map;
  }

  function init(root) {
    var grid = root.querySelector('[data-pgrid]');
    var chipsEl = root.querySelector('[data-chips]');
    var searchEl = root.querySelector('[data-search]');
    var countEl = root.querySelector('[data-count]');
    var sortEl = root.querySelector('[data-sort]');
    var emptyEl = root.querySelector('[data-empty]');
    var subwrapEl = root.querySelector('[data-subwrap]');
    var subchipsEl = root.querySelector('[data-subchips]');
    if (!grid) return;

    var handle = root.getAttribute('data-handle');
    var WALLET_ORDER = [
      'matte-black-leather-long-wallet-minimalist-slim-bifold-for-men-by-bm7',
      'premium-long-zip-leather-wallet-classic-black-by-bm7',
      'matter-brown-leather-long-size-wallet-for-men-by-bm7',
      'matte-brown-leather-long-wallet-minimalist-slim-bifold-for-men-by-bm7',
      'premium-dollar-size-leather-wallet-with-magnetic-closure',
      'classic-tan-leather-cheque-book-black-wallet-by-bm7',
      'bm-obsidian-premium-black-leather-bifold-wallet',
      'sleek-gray-leather-wallet-modern-minimal-by-bm7'
    ];
    function walletRank(h) {
      var i = WALLET_ORDER.indexOf(h);
      return i < 0 ? 999 : i;
    }
    var PERFUME_ORDER = [
      '7-by-bm7',
      'oud-by-bm7',
      'whisper-by-bm7',
      'moonlight-by-bm7',
      '7-gold-by-bm7-bilal-marth-7'
    ];
    function perfumeRank(h) {
      var i = PERFUME_ORDER.indexOf(h);
      return i < 0 ? 999 : i;
    }
    var moneyFormat = '${{amount}}';
    var overrides = {};
    var categories = [];
    try {
      var moneyNode = root.querySelector('[data-money]');
      if (moneyNode) moneyFormat = JSON.parse(moneyNode.textContent) || moneyFormat;
    } catch (e) {}
    try {
      var ovNode = root.querySelector('[data-overrides]');
      if (ovNode) overrides = JSON.parse(ovNode.textContent) || {};
    } catch (e) {}
    var extraChips = [];
    var supplementHandles = [];
    var supplementProductHandles = [];
    var subcategories = {};
    try {
      var catNode = root.querySelector('[data-categories]');
      if (catNode) categories = parseCategories(JSON.parse(catNode.textContent));
    } catch (e) {}
    try {
      var subNode = root.querySelector('[data-subcategories]');
      if (subNode) subcategories = parseSubcategories(JSON.parse(subNode.textContent));
    } catch (e) {}
    try {
      var extraNode = root.querySelector('[data-extra-chips]');
      if (extraNode) extraChips = JSON.parse(extraNode.textContent) || [];
    } catch (e) {}
    try {
      var supNode = root.querySelector('[data-supplement-collections]');
      if (supNode) {
        var rawSup = JSON.parse(supNode.textContent);
        supplementHandles = String(rawSup || '')
          .split(',')
          .map(function (s) { return s.trim(); })
          .filter(Boolean);
      }
    } catch (e) {}
    try {
      var supProdNode = root.querySelector('[data-supplement-products]');
      if (supProdNode) {
        var rawProd = JSON.parse(supProdNode.textContent);
        supplementProductHandles = String(rawProd || '')
          .split(',')
          .map(function (s) { return s.trim(); })
          .filter(Boolean);
      }
    } catch (e) {}

    function categoryOf(title, productHandle, optionText, productType, tags) {
      var t = title.toLowerCase();
      var h = (productHandle || '').toLowerCase().replace(/-/g, ' ');
      var o = (optionText || '').toLowerCase();
      var ty = (productType || '').toLowerCase();
      var tg = Array.isArray(tags)
        ? tags.join(' ').toLowerCase()
        : String(tags || '').toLowerCase().replace(/,/g, ' ');
      // Prefer variant/option text first (e.g. shawl Color) so title typos don't misfile.
      if (o) {
        for (var i = 0; i < categories.length; i++) {
          var kws = categories[i].kw;
          for (var k = 0; k < kws.length; k++) {
            if (kws[k] && o.indexOf(kws[k]) > -1) return categories[i].label;
          }
        }
      }
      for (var j = 0; j < categories.length; j++) {
        var kws2 = categories[j].kw;
        for (var m = 0; m < kws2.length; m++) {
          if (
            kws2[m] &&
            (t.indexOf(kws2[m]) > -1 ||
              h.indexOf(kws2[m]) > -1 ||
              ty.indexOf(kws2[m]) > -1 ||
              tg.indexOf(kws2[m]) > -1)
          ) {
            return categories[j].label;
          }
        }
      }
      return 'Other';
    }

    function optionTextOf(p) {
      var parts = [];
      (p.variants || []).forEach(function (vr) {
        if (!vr) return;
        if (vr.title && String(vr.title).toLowerCase() !== 'default title') parts.push(vr.title);
        if (vr.option1) parts.push(vr.option1);
        if (vr.option2) parts.push(vr.option2);
        if (vr.option3) parts.push(vr.option3);
      });
      (p.options || []).forEach(function (opt) {
        if (!opt) return;
        if (opt.name) parts.push(opt.name);
        (opt.values || []).forEach(function (val) { if (val) parts.push(val); });
      });
      return parts.join(' ');
    }

    // Sub-variant within a parent category. Title-only match: some Platinum
    // products carry blue-mint handles, so matching the handle would misfile them.
    function subcatOf(parent, title) {
      var subs = subcategories[parent];
      if (!subs) return '';
      var t = (title || '').toLowerCase();
      for (var i = 0; i < subs.length; i++) {
        var kws = subs[i].kw;
        for (var k = 0; k < kws.length; k++) {
          if (t.indexOf(kws[k]) > -1) return subs[i].label;
        }
      }
      return '';
    }

    function hasSub(label) {
      return !!(subcategories[label] && subcategories[label].length);
    }

    var products = [];
    var activeCat = 'all';
    var activeSub = 'all';
    var query = '';

    function loadCollection(collectionHandle) {
      var all = [];
      var pageSize = 50; /* storefront products.json commonly caps at 50 */
      function page(p) {
        return fetch(
          '/collections/' + collectionHandle + '/products.json?limit=' + pageSize + '&page=' + p,
          { headers: { Accept: 'application/json' } }
        ).then(function (r) {
          if (!r.ok) throw new Error('bad status');
          return r.json();
        }).then(function (data) {
          var list = (data && data.products) || [];
          all = all.concat(list);
          if (list.length === pageSize && p < 20) return page(p + 1);
          return all;
        });
      }
      return page(1);
    }

    function loadProduct(productHandle) {
      return fetch('/products/' + productHandle + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('bad status');
        return r.json();
      }).then(function (p) {
        if (!p || !p.handle) return null;
        var imgs = (p.images || []).map(function (src) {
          return typeof src === 'string' ? { src: src } : src;
        });
        // The /products/.js endpoint returns prices in integer cents, whereas
        // /collections/.json returns decimal-string dollars. Normalize to the
        // .json shape so buildModel's parseFloat(price)*100 stays correct.
        var variants = (p.variants || []).map(function (v) {
          var compare = v.compare_at_price != null && v.compare_at_price !== ''
            ? (parseFloat(v.compare_at_price) / 100).toFixed(2)
            : null;
          return {
            price: (parseFloat(v.price || 0) / 100).toFixed(2),
            compare_at_price: compare,
            available: v.available
          };
        });
        return {
          id: p.id,
          title: p.title,
          handle: p.handle,
          product_type: p.type || '',
          tags: p.tags,
          variants: variants,
          images: imgs
        };
      }).catch(function () { return null; });
    }

    function loadAll() {
      var handles = [handle].concat(
        supplementHandles.filter(function (h) { return h && h !== handle; })
      );
      var collPromise = Promise.all(handles.map(loadCollection));
      var prodPromise = Promise.all(supplementProductHandles.map(loadProduct));
      return Promise.all([collPromise, prodPromise]).then(function (results) {
        var lists = results[0];
        var extras = results[1];
        var merged = [];
        var seen = {};
        lists.forEach(function (list) {
          (list || []).forEach(function (p) {
            if (!p || !p.handle || seen[p.handle]) return;
            seen[p.handle] = true;
            merged.push(p);
          });
        });
        (extras || []).forEach(function (p) {
          if (!p || !p.handle || seen[p.handle]) return;
          seen[p.handle] = true;
          merged.push(p);
        });
        return merged;
      });
    }

    function buildModel(raw) {
      return raw.map(function (p, idx) {
        var title = String(p.title || '').replace(/\s+/g, ' ').trim();
        var imgs = (p.images || []).map(function (i) { return i.src; });
        var ov = overrides[p.handle];
        var v = (p.variants && p.variants[0]) || {};
        var cat = categoryOf(title, p.handle, optionTextOf(p), p.product_type || '', p.tags || []);
        var soldOut = false;
        if (p.variants && p.variants.length) {
          soldOut = p.variants.every(function (vr) { return vr && vr.available === false; });
        }
        var price = Math.round(parseFloat(v.price || '0') * 100);
        var compare = v.compare_at_price != null && v.compare_at_price !== ''
          ? Math.round(parseFloat(v.compare_at_price) * 100)
          : 0;
        var onSale = !soldOut && compare > price && price > 0;
        var salePct = onSale ? Math.round(((compare - price) / compare) * 100) : 0;
        return {
          idx: idx,
          title: title,
          handle: p.handle,
          type: p.product_type || '',
          price: price,
          compare: compare,
          onSale: onSale,
          salePct: salePct,
          imgA: ov && ov.a ? ov.a : (imgs[0] || ''),
          imgB: ov && ov.b ? ov.b : modelImage(imgs),
          cat: cat,
          subcat: subcatOf(cat, title),
          soldOut: soldOut
        };
      });
    }

    function cardHTML(p) {
      var display = p.title.replace(/\s+by\s+bm7/ig, '');
      var label = p.type === 'Gift Box' ? 'Gift Boxes' : ((p.type || '').toLowerCase() === 'wallet' ? 'Leather' : (p.type || 'BM7'));
      var a = withWidth(p.imgA, 800);
      var b = withWidth(p.imgB, 800);
      var media = '';
      if (a) media += '<img class="a" src="' + esc(a) + '" alt="' + esc(display) + '" loading="lazy" width="800" height="1000">';
      if (b && b !== a) media += '<img class="b" src="' + esc(b) + '" alt="' + esc(display) + '" loading="lazy" width="800" height="1000">';
      if (p.soldOut) media += '<span class="pc__so">Sold Out</span>';
      else if (p.onSale) media += '<span class="pc__sale">' + (p.salePct > 0 ? p.salePct + '% off' : 'Sale') + '</span>';
      var priceHtml = p.onSale
        ? '<s>' + formatMoney(p.compare, moneyFormat) + '</s>' + formatMoney(p.price, moneyFormat)
        : formatMoney(p.price, moneyFormat);
      return '<a class="pc' + (p.soldOut ? ' pc--soldout' : '') + '" href="/products/' + esc(p.handle) + '" data-cat="' + esc(p.cat) + '" data-sub="' + esc(p.subcat || '') + '" data-title="' + esc(p.title.toLowerCase()) + '">' +
        '<div class="pc__m">' + media + '<div class="pc__q">Quick View</div></div>' +
        '<div class="pc__l">' + esc(label) + '</div>' +
        '<div class="pc__t">' + esc(display) + '</div>' +
        '<div class="pc__p">' + priceHtml + '</div>' +
        '</a>';
    }

    function renderGrid(list) {
      grid.innerHTML = list.map(cardHTML).join('');
    }

    function categoryLabels() {
      return categories.map(function (c) { return c.label; });
    }

    function isFilterCategory(label) {
      return categoryLabels().indexOf(label) > -1;
    }

    function extraChipsHTML(skipLabels) {
      var skip = {};
      (skipLabels || []).forEach(function (l) { skip[l] = true; });
      return (extraChips || []).map(function (c) {
        if (!c || !c.label || skip[c.label]) return '';
        if (isFilterCategory(c.label)) {
          return '<button type="button" class="chip" data-cat="' + esc(c.label) + '">' + esc(c.label) + '</button>';
        }
        var href = c.link && c.link !== '#' ? c.link : '';
        if (!href) {
          return '<button type="button" class="chip" data-cat="' + esc(c.label) + '">' + esc(c.label) + '</button>';
        }
        return '<a class="chip chip--link" href="' + esc(href) + '">' + esc(c.label) + '</a>';
      }).join('');
    }

    function filtersEnabled() {
      return categories.length > 0 || (extraChips && extraChips.length > 0);
    }

    // A parent chip renders with a caret + hover dropdown when it has sub-variants.
    function chipHTML(label) {
      if (hasSub(label)) {
        var items = '';
        subcategories[label].forEach(function (s) {
          items += '<button type="button" class="dditem" data-cat="' + esc(label) + '" data-sub="' + esc(s.label) + '">' + esc(s.label) + '</button>';
        });
        return '<span class="chipwrap" data-parent="' + esc(label) + '">' +
          '<button type="button" class="chip chip--parent" data-cat="' + esc(label) + '">' + esc(label) +
          '<svg class="cev" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>' +
          '</button>' +
          '<div class="dropdown" data-dropdown>' + items + '</div>' +
          '</span>';
      }
      return '<button type="button" class="chip" data-cat="' + esc(label) + '">' + esc(label) + '</button>';
    }

    function renderSubchips(parent) {
      if (!subwrapEl || !subchipsEl) return;
      if (!hasSub(parent)) {
        subwrapEl.style.display = 'none';
        subchipsEl.innerHTML = '';
        return;
      }
      var html = '';
      subcategories[parent].forEach(function (s) {
        html += '<button type="button" class="chip' + (activeSub === s.label ? ' on' : '') + '" data-sub="' + esc(s.label) + '">' + esc(s.label) + '</button>';
      });
      subchipsEl.innerHTML = html;
      subwrapEl.style.display = '';
    }

    function firstSub(parent) {
      var subs = subcategories[parent];
      return subs && subs.length ? subs[0].label : 'all';
    }

    // Single source of truth for filter state (used by parent chips + dropdown).
    function selectCategory(cat, sub) {
      activeCat = cat || 'all';
      if (hasSub(activeCat) && (!sub || sub === 'all')) {
        activeSub = firstSub(activeCat);
      } else {
        activeSub = sub || 'all';
      }
      if (chipsEl) {
        chipsEl.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('on'); });
        var sel = activeCat === 'all'
          ? chipsEl.querySelector('.chip[data-cat="all"]')
          : chipsEl.querySelector('.chip[data-cat="' + activeCat + '"]');
        if (sel) sel.classList.add('on');
        chipsEl.querySelectorAll('.dditem').forEach(function (d) {
          var on = d.getAttribute('data-cat') === activeCat && d.getAttribute('data-sub') === activeSub;
          d.classList.toggle('on', on);
        });
      }
      if (hasSub(activeCat)) renderSubchips(activeCat);
      else if (subwrapEl) { subwrapEl.style.display = 'none'; if (subchipsEl) subchipsEl.innerHTML = ''; }
      apply();
    }

    function buildChips() {
      if (!filtersEnabled()) {
        if (chipsEl) chipsEl.style.display = 'none';
        return;
      }
      var present = {};
      products.forEach(function (p) { present[p.cat] = (present[p.cat] || 0) + 1; });
      var ordered = categories.map(function (c) { return c.label; });
      if (ordered.length < 1 && !extraChips.length && !present.Other) { chipsEl.style.display = 'none'; return; }
      var html = '<button type="button" class="chip on" data-cat="all">All</button>';
      ordered.forEach(function (l) {
        html += chipHTML(l);
      });
      html += extraChipsHTML(ordered);
      chipsEl.innerHTML = html;
      chipsEl.style.display = '';
    }

    function apply() {
      var cards = grid.querySelectorAll('.pc');
      var shown = 0;
      cards.forEach(function (c) {
        var okCat = activeCat === 'all' || c.getAttribute('data-cat') === activeCat;
        var okSub = activeSub === 'all' || c.getAttribute('data-sub') === activeSub;
        var okQ = !query || c.getAttribute('data-title').indexOf(query) > -1;
        var show = okCat && okSub && okQ;
        c.style.display = show ? '' : 'none';
        if (show) shown++;
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' Piece' : ' Pieces');
      if (emptyEl) emptyEl.style.display = shown ? 'none' : '';
    }

    function wire() {
      if (chipsEl) {
        chipsEl.addEventListener('click', function (e) {
          var dd = e.target.closest('.dditem');
          if (dd) {
            e.preventDefault();
            var ddwrap = dd.closest('.chipwrap');
            if (ddwrap) {
              var op = ddwrap.querySelector('.dropdown');
              if (op) op.classList.remove('open');
            }
            selectCategory(dd.getAttribute('data-cat'), dd.getAttribute('data-sub') || 'all');
            return;
          }
          var btn = e.target.closest('.chip');
          if (!btn) return;
          if (btn.classList.contains('chip--link')) return;
          e.preventDefault();
          // On touch (no hover), a tap on a parent chip toggles its dropdown too.
          selectCategory(btn.getAttribute('data-cat') || 'all', 'all');
        });
      }
      if (subchipsEl) {
        subchipsEl.addEventListener('click', function (e) {
          var btn = e.target.closest('.chip');
          if (!btn) return;
          e.preventDefault();
          activeSub = btn.getAttribute('data-sub') || 'all';
          subchipsEl.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('on'); });
          btn.classList.add('on');
          if (chipsEl) {
            chipsEl.querySelectorAll('.dditem').forEach(function (d) {
              var on = d.getAttribute('data-cat') === activeCat && d.getAttribute('data-sub') === activeSub;
              d.classList.toggle('on', on);
            });
          }
          apply();
        });
      }
      if (searchEl) {
        searchEl.addEventListener('input', function () {
          query = this.value.toLowerCase().trim();
          apply();
        });
      }
      if (sortEl) {
        sortEl.addEventListener('change', function () {
          var v = this.value;
          var arr = products.slice();
          if (v === 'price-ascending') arr.sort(function (a, b) { return a.price - b.price; });
          else if (v === 'price-descending') arr.sort(function (a, b) { return b.price - a.price; });
          else if (v === 'title-ascending') arr.sort(function (a, b) { return a.title.localeCompare(b.title); });
          else if (handle === 'wallets') arr.sort(function (a, b) { return walletRank(a.handle) - walletRank(b.handle); });
          else if (handle === 'perfumes') arr.sort(function (a, b) { return perfumeRank(a.handle) - perfumeRank(b.handle); });
          else arr.sort(function (a, b) { return a.idx - b.idx; });
          renderGrid(arr);
          apply();
        });
      }
    }

    // Fallback: enable chips/search over the server-rendered cards already in DOM.
    function fallbackFromDOM() {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.pc'));
      if (!cards.length) return;
      if (!filtersEnabled()) {
        if (chipsEl) chipsEl.style.display = 'none';
        wire();
        apply();
        return;
      }
      var present = {};
      cards.forEach(function (c) {
        var titleNode = c.querySelector('.pc__t');
        var title = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
        var cat = categoryOf(title, c.getAttribute('href') ? c.getAttribute('href').split('/products/').pop() : '');
        c.setAttribute('data-cat', cat);
        c.setAttribute('data-sub', subcatOf(cat, title));
        c.setAttribute('data-title', title.toLowerCase());
        present[cat] = (present[cat] || 0) + 1;
      });
      var ordered = categories.map(function (x) { return x.label; });
      if ((ordered.length >= 1 || extraChips.length || present.Other) && chipsEl) {
        var html = '<button type="button" class="chip on" data-cat="all">All</button>';
        ordered.forEach(function (l) {
          html += chipHTML(l);
        });
        html += extraChipsHTML(ordered);
        chipsEl.innerHTML = html;
        chipsEl.style.display = '';
      } else if (chipsEl) {
        chipsEl.style.display = 'none';
      }
      wire();
      apply();
    }

    if (sortEl) sortEl.value = sortEl.getAttribute('data-current') || 'manual';

    loadAll().then(function (raw) {
      if (!raw || !raw.length) { fallbackFromDOM(); return; }
      products = buildModel(raw);
      if (handle === 'wallets') {
        products.sort(function (a, b) { return walletRank(a.handle) - walletRank(b.handle); });
      } else if (handle === 'perfumes') {
        products.sort(function (a, b) { return perfumeRank(a.handle) - perfumeRank(b.handle); });
      }
      buildChips();
      renderGrid(products);
      wire();
      apply();
      var pag = root.querySelector('[data-paginate]');
      if (pag) pag.style.display = 'none';
    }).catch(function () {
      fallbackFromDOM();
    });
  }

  function boot() {
    document.querySelectorAll('[data-bm7-collection]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
